webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _datePicker = __webpack_require__(553);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _base = __webpack_require__(552);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _datePicker3 = __webpack_require__(539);
	
	var _datePicker4 = _interopRequireDefault(_datePicker3);
	
	var _vue = __webpack_require__(26);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(569);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vuex = __webpack_require__(586);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vueRouter = __webpack_require__(585);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _column = __webpack_require__(202);
	
	var _column2 = _interopRequireDefault(_column);
	
	var _funnel = __webpack_require__(572);
	
	var _funnel2 = _interopRequireDefault(_funnel);
	
	var _heat = __webpack_require__(573);
	
	var _heat2 = _interopRequireDefault(_heat);
	
	var _point = __webpack_require__(205);
	
	var _point2 = _interopRequireDefault(_point);
	
	var _line = __webpack_require__(203);
	
	var _line2 = _interopRequireDefault(_line);
	
	var _dashboard = __webpack_require__(571);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _multipleColumn = __webpack_require__(204);
	
	var _multipleColumn2 = _interopRequireDefault(_multipleColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component(_datePicker4.default.name, _datePicker4.default);
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
	  state: {
	    count: 0,
	    color: ['#325B69', '#698570', '#AE5548', '#6D9EA8', '#9CC2B0', '#C98769']
	  }
	});
	var router = new _vueRouter2.default({
	  routes: [{
	    path: '/column',
	    component: _column2.default
	  }, {
	    path: '/funnel',
	    component: _funnel2.default
	  }, {
	    path: '/heat',
	    component: _heat2.default
	  }, {
	    path: '/point',
	    component: _point2.default
	  }, {
	    path: '/dashboard',
	    component: _dashboard2.default
	  }, {
	    path: '/multipleColumn',
	    component: _multipleColumn2.default
	  }, {
	    path: '/line',
	    component: _line2.default
	  }],
	  linkActiveClass: 'active'
	});
	new _vue2.default({
	  router: router,
	  store: store,
	  template: '<App>',
	  components: {
	    App: _App2.default
	  },
	  data: {
	    eventHub: new _vue2.default(),
	    charts: []
	  }
	}).$mount('#app');
	
	router.push('dashboard');

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(560)
	
	var Component = __webpack_require__(22)(
	  /* script */
	  __webpack_require__(248),
	  /* template */
	  __webpack_require__(580),
	  /* scopeId */
	  "data-v-6cb5db06",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(558)
	
	var Component = __webpack_require__(22)(
	  /* script */
	  __webpack_require__(246),
	  /* template */
	  __webpack_require__(578),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(557)
	
	var Component = __webpack_require__(22)(
	  /* script */
	  __webpack_require__(244),
	  /* template */
	  __webpack_require__(577),
	  /* scopeId */
	  "data-v-44225e5d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(556)
	
	var Component = __webpack_require__(22)(
	  /* script */
	  __webpack_require__(250),
	  /* template */
	  __webpack_require__(576),
	  /* scopeId */
	  "data-v-30ee6e5d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(559)
	
	var Component = __webpack_require__(22)(
	  /* script */
	  __webpack_require__(251),
	  /* template */
	  __webpack_require__(579),
	  /* scopeId */
	  "data-v-5db83946",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(562)
	
	var Component = __webpack_require__(22)(
	  /* script */
	  __webpack_require__(252),
	  /* template */
	  __webpack_require__(582),
	  /* scopeId */
	  "data-v-be588a02",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(89);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      seller: {}
	    };
	  },
	  created: function created() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    isChecked: {
	      type: Boolean,
	      default: true
	    }
	  }
	};

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(47);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _header = __webpack_require__(62);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _filter = __webpack_require__(82);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      legendArr: [],
	      color: this.$store.state.color,
	      myChart: {},
	      name: '柱状图'
	    };
	  },
	
	  methods: {
	    _init: function _init() {
	      this.legendArr = this.myChart.getOption().series;
	      this.legendArr.forEach(function (data) {
	        data.selected = true;
	      });
	      this.$root.charts.push(this.myChart);
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  components: {
	    'v-header': _header2.default,
	    'v-filter': _filter2.default
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.columnChart .main'));
	    this.myChart.setOption({
	      title: {
	        show: false
	      },
	      tooltip: {
	        trigger: 'axis'
	      },
	      legend: {
	        show: false
	      },
	      toolbox: {
	        show: false
	      },
	      color: this.color,
	      calculable: true,
	      xAxis: [{
	        name: '产品',
	        type: 'category',
	        axisLine: {
	          show: false
	        },
	        axisTick: {
	          show: false
	        },
	        nameTextStyle: {
	          color: 'rgba(255, 255, 255, 0.69)'
	        },
	        axisLabel: {
	          textStyle: {
	            color: 'white'
	          }
	        },
	        data: ['产品1', '产品2']
	      }],
	      yAxis: [{
	        axisLine: {
	          show: false
	        },
	        nameLocation: 'end',
	        nameGap: 20,
	        nameRotate: 0,
	        axisTick: {
	          show: false
	        },
	        splitLine: {
	          lineStyle: {
	            color: ['rgba(230, 230, 230, 0.2)']
	          }
	        },
	        axisLabel: {
	          textStyle: {
	            color: 'white',
	            fontSize: 14
	          }
	        },
	        name: '数量',
	        type: 'value',
	        nameTextStyle: {
	          color: 'rgba(255, 255, 255, 0.69)'
	        }
	      }],
	      series: [{
	        name: '标签1',
	        type: 'bar',
	        data: [2.0, 4.9],
	        barWidth: 16,
	        barGap: 0
	      }, {
	        name: '标签2',
	        type: 'bar',
	        data: [2.6, 5.9],
	        barWidth: 16,
	        barGap: 0
	      }, {
	        name: '标签3',
	        type: 'bar',
	        data: [2.0, 6.4],
	        barWidth: 16,
	        barGap: 0
	      }, {
	        name: '标签4',
	        type: 'bar',
	        data: [4.0, 5.9],
	        barWidth: 16,
	        barGap: 0
	      }, {
	        name: '标签5',
	        type: 'bar',
	        data: [5.6, 4.9],
	        barWidth: 16,
	        barGap: 0
	      }, {
	        name: '标签6',
	        type: 'bar',
	        data: [2.0, 3.4],
	        barWidth: 16,
	        barGap: 0
	      }]
	    });
	    this._init();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _column = __webpack_require__(202);
	
	var _column2 = _interopRequireDefault(_column);
	
	var _line = __webpack_require__(203);
	
	var _line2 = _interopRequireDefault(_line);
	
	var _multipleColumn = __webpack_require__(204);
	
	var _multipleColumn2 = _interopRequireDefault(_multipleColumn);
	
	var _point = __webpack_require__(205);
	
	var _point2 = _interopRequireDefault(_point);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      items: []
	    };
	  },
	  mounted: function mounted() {
	    this._init();
	  },
	
	  methods: {
	    _resize: function _resize() {
	      this.$root.charts.forEach(function (myChart) {
	        myChart.resize();
	      });
	    },
	    _init: function _init() {
	      this.items = document.querySelectorAll('.flex-container .item');
	      for (var i = 0; i < this.items.length; i++) {
	        this.items[i].dataset.order = i + 1;
	      }
	    },
	    clickChart: function clickChart(clickIndex) {
	      var activeItem = document.querySelector('.flex-container .active');
	      var activeIndex = activeItem.dataset.order;
	      var clickItem = this.items[clickIndex - 1];
	      if (activeIndex === clickIndex) {
	        return;
	      }
	      activeItem.classList.remove('active');
	      clickItem.classList.add('active');
	      this._setStyle(clickItem, activeItem);
	    },
	    _setStyle: function _setStyle(el1, el2) {
	      var transform1 = el1.style.transform;
	      var transform2 = el2.style.transform;
	      el1.style.transform = transform2;
	      el2.style.transform = transform1;
	    }
	  },
	  components: {
	    column: _column2.default,
	    multipleColumn: _multipleColumn2.default,
	    point: _point2.default,
	    'v-line': _line2.default
	  }
	};

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(253);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(256);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _checkbox = __webpack_require__(570);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    myChart: {
	      tyoe: Object,
	      default: {}
	    }
	  },
	  data: function data() {
	    return {
	      startDate: '2015.12.04',
	      endDate: '2016.01.15',
	      pro_filter_flag: false,
	      selectAll_flag: true,
	      pro_list: [],
	      option: {},
	      resetOption: {}, // 存储最开始的数据,
	      preClass: '',
	      showProduct: false,
	      showTime: false
	    };
	  },
	  mounted: function mounted() {
	    this._init();
	  },
	
	  methods: {
	    _init: function _init() {
	      this.prevClass = this.$parent.$el._prevClass;
	      this.option = this.myChart.getOption();
	      this.resetOption = this._deepCopy(this.myChart.getOption());
	      this._initProList();
	    },
	    _initProList: function _initProList() {
	      var arr = [];
	      if (this.prevClass !== 'point') {
	        this.showProduct = true;
	        this.option.xAxis[0].data.forEach(function (pro, index) {
	          arr.push({
	            name: pro,
	            selected: true
	          });
	        });
	        this.pro_list = arr;
	      }
	    },
	    _deepCopy: function _deepCopy(obj) {
	      var str = void 0,
	          newobj = void 0;
	      str = newobj = obj.constructor === Array ? [] : {};
	      if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
	        return;
	      } else if (window.JSON) {
	        str = (0, _stringify2.default)(obj); // 系列化对象
	        newobj = JSON.parse(str); // 还原
	      } else {
	        for (var i in obj) {
	          newobj[i] = (0, _typeof3.default)(obj[i]) === 'object' ? cloneObj(obj[i]) : obj[i];
	        }
	      }
	      return newobj;
	    },
	    pro_toggle: function pro_toggle(pro, index) {
	      pro.selected = !pro.selected;
	      this.selectAll_flag = this.isSelectAll();
	      this.redraw();
	    },
	    redraw: function redraw() {
	      var option = this._deepCopy(this.resetOption);
	      var count = 0;
	      this.pro_list.forEach(function (pro, index) {
	        index = index - count;
	        if (!pro.selected) {
	          option.xAxis[0].data.splice(index, 1);
	          option.series.forEach(function (obj) {
	            obj.data.splice(index, 1);
	          });
	          count++;
	        }
	      });
	      this.myChart.setOption(option);
	    },
	    isSelectAll: function isSelectAll() {
	      var flag = true;
	      this.pro_list.forEach(function (pro) {
	        if (!pro.selected) {
	          flag = false;
	        }
	      });
	      return flag;
	    },
	    selectAll: function selectAll() {
	      var _this = this;
	
	      this.selectAll_flag = !this.selectAll_flag;
	      this.pro_list.forEach(function (pro) {
	        pro.selected = _this.selectAll_flag;
	      });
	      this.redraw();
	    },
	    showProPane: function showProPane() {
	      this.pro_filter_flag = !this.pro_filter_flag;
	    }
	  },
	  components: {
	    checkbox: _checkbox2.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	
	exports.default = {};

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    legendArr: {
	      type: Array,
	      default: []
	    },
	    myChart: Object,
	    name: String
	  },
	  created: function created() {
	    this._init();
	  },
	  data: function data() {
	    return {
	      styleArr: [],
	      color: this.$store.state.color
	    };
	  },
	
	  methods: {
	    _init: function _init() {
	      var _this = this;
	
	      this.color.forEach(function (color) {
	        _this.styleArr.push({
	          background: color,
	          border: '1px solid' + color
	        });
	      });
	    },
	    highlight: function highlight(index) {
	      this.myChart.dispatchAction({
	        type: 'highlight',
	        seriesIndex: index
	      });
	    },
	    donwplay: function donwplay(index) {
	      this.myChart.dispatchAction({
	        type: 'downplay',
	        seriesIndex: index
	      });
	    },
	    legendToggle: function legendToggle(legend) {
	      legend.selected = !legend.selected;
	      this.myChart.dispatchAction({
	        type: 'legendToggleSelect',
	        name: legend.name
	      });
	      this.changeStyle();
	    },
	    changeStyle: function changeStyle() {
	      var _this2 = this;
	
	      this.legendArr.forEach(function (data, index) {
	        if (data.selected) {
	          _this2.styleArr[index].background = _this2.color[index];
	          _this2.styleArr[index].border = '1px solid' + _this2.color[index];
	        } else {
	          _this2.styleArr[index].background = 'transparent';
	          _this2.styleArr[index].border = '1px solid #9C8C84';
	        }
	      });
	    }
	  }
	};

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(89);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _echarts = __webpack_require__(47);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _china = __webpack_require__(196);
	
	var _china2 = _interopRequireDefault(_china);
	
	var _header = __webpack_require__(62);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  created: function created() {
	    this._getCityData();
	  },
	  data: function data() {
	    return {
	      legendArr: [],
	      color: this.$store.state.color,
	      myChart: {},
	      geoCoordMap: {},
	      name: '热力图'
	    };
	  },
	
	  methods: {
	    _init: function _init(options) {
	      this.myChart = _echarts2.default.init(document.querySelector('.heat .main'));
	      this.myChart.setOption(options);
	      this.legendArr = options.series;
	      this.legendArr.forEach(function (data) {
	        data.selected = true;
	      });
	    },
	    _getCityData: function _getCityData() {
	      var _this = this;
	
	      _axios2.default.get('static/data/cityData.json').then(function (res) {
	        _this.geoCoordMap = res.data;
	      });
	    },
	    convertData: function convertData(data) {
	      var res = [];
	      for (var i = 0; i < data.length; i++) {
	        var geoCoord = this.geoCoordMap[data[i].name];
	        if (geoCoord) {
	          res.push(geoCoord.concat(data[i].value));
	        }
	      }
	      return res;
	    }
	  },
	  components: {
	    'v-header': _header2.default
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    _axios2.default.get('static/data/heat/testData.json').then(function (res) {
	      var options = {
	        title: {
	          text: '全国主要城市空气质量',
	          left: 'center',
	          textStyle: {
	            color: '#fff'
	          }
	        },
	        backgroundColor: '#404a59',
	        visualMap: {
	          min: 0,
	          max: 500,
	          splitNumber: 5,
	          inRange: {
	            color: ['#d94e5d', '#eac736', '#50a3ba'].reverse()
	          },
	          textStyle: {
	            color: '#fff'
	          }
	        },
	        geo: {
	          map: 'china',
	          label: {
	            emphasis: {
	              show: false
	            }
	          },
	          roam: true,
	          itemStyle: {
	            normal: {
	              areaColor: '#323c48',
	              borderColor: '#111'
	            },
	            emphasis: {
	              areaColor: '#2a333d'
	            }
	          }
	        },
	        series: [{
	          name: 'AQI',
	          type: 'heatmap',
	          coordinateSystem: 'geo',
	          data: _this2.convertData(res.data)
	        }]
	      };
	      window.onresize = _this2.myChart.resize;
	      _this2._init(options);
	    });
	  }
	};

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(47);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _header = __webpack_require__(62);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _filter = __webpack_require__(82);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      legendArr: [],
	      color: this.$store.state.color,
	      myChart: {},
	      name: '折线图'
	    };
	  },
	
	  methods: {
	    _init: function _init() {
	      this.legendArr = this.myChart.getOption().series;
	      this.legendArr.forEach(function (data) {
	        data.selected = true;
	      });
	      this.$root.charts.push(this.myChart);
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  components: {
	    'v-header': _header2.default,
	    'v-filter': _filter2.default
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.line .main'));
	    this.myChart.setOption({
	      title: {
	        show: false
	      },
	      tooltip: {
	        trigger: 'axis'
	      },
	      legend: {
	        show: false
	      },
	      toolbox: {
	        show: false
	      },
	      color: this.color,
	      calculable: true,
	      xAxis: [{
	        name: '产品',
	        type: 'category',
	        axisLine: {
	          show: false
	        },
	        axisTick: {
	          show: false
	        },
	        nameTextStyle: {
	          color: 'rgba(255, 255, 255, 0.69)'
	        },
	        axisLabel: {
	          textStyle: {
	            color: 'white'
	          }
	        },
	        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
	      }],
	      yAxis: [{
	        axisLine: {
	          show: false
	        },
	        nameLocation: 'end',
	        nameGap: 20,
	        nameRotate: 0,
	        axisTick: {
	          show: false
	        },
	        splitLine: {
	          lineStyle: {
	            color: ['rgba(230, 230, 230, 0.2)']
	          }
	        },
	        axisLabel: {
	          textStyle: {
	            color: 'white',
	            fontSize: 14
	          }
	        },
	        name: '数量',
	        type: 'value',
	        nameTextStyle: {
	          color: 'rgba(255, 255, 255, 0.69)'
	        }
	      }],
	      series: [{
	        name: '标签1',
	        type: 'line',
	        stack: '总量',
	        data: [120, 132, 101, 134, 90, 230, 210]
	      }, {
	        name: '标签2',
	        type: 'line',
	        stack: '总量',
	        data: [220, 182, 191, 234, 290, 330, 310]
	      }, {
	        name: '标签3',
	        type: 'line',
	        stack: '总量',
	        data: [150, 232, 201, 154, 190, 330, 410]
	      }, {
	        name: '标签4',
	        type: 'line',
	        stack: '总量',
	        data: [320, 332, 301, 334, 390, 330, 320]
	      }, {
	        name: '标签5',
	        type: 'line',
	        stack: '总量',
	        data: [820, 932, 901, 934, 1290, 1330, 1320]
	      }]
	    });
	    this._init();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(47);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _header = __webpack_require__(62);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _filter = __webpack_require__(82);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      legendArr: [],
	      color: this.$store.state.color,
	      styleArr: [],
	      myChart: {},
	      name: '复杂柱状图'
	    };
	  },
	
	  methods: {
	    _init: function _init() {
	      this.legendArr = this.myChart.getOption().series;
	      this.legendArr.forEach(function (data) {
	        data.selected = true;
	      });
	      this.$root.charts.push(this.myChart);
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  components: {
	    'v-header': _header2.default,
	    'v-filter': _filter2.default
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.multipleColumn .main'));
	    this.myChart.setOption({
	      title: {
	        show: false
	      },
	      tooltip: {
	        trigger: 'axis'
	      },
	      legend: {
	        show: false
	      },
	      toolbox: {
	        show: false
	      },
	      color: this.color,
	      calculable: true,
	      xAxis: [{
	        name: '产品',
	        type: 'category',
	        axisLine: {
	          show: false
	        },
	        axisTick: {
	          show: false
	        },
	        nameTextStyle: {
	          color: 'rgba(255, 255, 255, 0.69)'
	        },
	        axisLabel: {
	          textStyle: {
	            color: 'white'
	          }
	        },
	        data: ['产品1', '产品2', '产品3', '产品4', '产品5']
	      }],
	      yAxis: [{
	        axisLine: {
	          show: false
	        },
	        nameLocation: 'end',
	        nameGap: 20,
	        nameRotate: 0,
	        axisTick: {
	          show: false
	        },
	        splitLine: {
	          lineStyle: {
	            color: ['rgba(230, 230, 230, 0.2)']
	          }
	        },
	        axisLabel: {
	          textStyle: {
	            color: 'white',
	            fontSize: 14
	          }
	        },
	        name: '数量',
	        type: 'value',
	        nameTextStyle: {
	          color: 'rgba(255, 255, 255, 0.69)'
	        }
	      }],
	      series: [{
	        name: '标签1',
	        stack: 'stack1',
	        type: 'bar',
	        data: [2.0, 4.9, 5.9, 3, 6],
	        barWidth: 16,
	        barGap: 0
	      }, {
	        name: '标签2',
	        stack: 'stack2',
	        type: 'bar',
	        data: [2.6, 5.9, 3.6, 6, 8],
	        barWidth: 16,
	        barGap: 0
	      }, {
	        name: '标签3',
	        stack: 'stack3',
	        type: 'bar',
	        data: [2.0, 6.4, 6.0, 4, 5],
	        barWidth: 16,
	        barGap: 0
	      }, {
	        name: '标签4',
	        stack: 'stack1',
	        type: 'bar',
	        data: [4.0, 5.9, 3, 3, 6],
	        barWidth: 16,
	        barGap: 0
	      }, {
	        name: '标签5',
	        stack: 'stack2',
	        type: 'bar',
	        data: [5.6, 4.9, 6, 5, 5],
	        barWidth: 16,
	        barGap: 0
	      }, {
	        name: '标签6',
	        stack: 'stack3',
	        type: 'bar',
	        data: [2.0, 3.4, 8],
	        barWidth: 16,
	        barGap: 0
	      }]
	    });
	    this._init();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(89);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _echarts = __webpack_require__(47);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _china = __webpack_require__(196);
	
	var _china2 = _interopRequireDefault(_china);
	
	var _header = __webpack_require__(62);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _filter = __webpack_require__(82);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var USER_NAME = 'elastic'; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var PSW = 'elasticl@ethical.cn';
	var AUTH_TOKEN = "Basic " + btoa(USER_NAME + ":" + PSW);
	
	exports.default = {
	  created: function created() {
	    this._getCityData();
	  },
	  data: function data() {
	    return {
	      legendArr: [],
	      color: this.$store.state.color,
	      myChart: {},
	      geoCoordMap: {},
	      name: '散点图'
	    };
	  },
	
	  methods: {
	    _init: function _init(options) {
	      this.myChart = _echarts2.default.init(document.querySelector('.point .main'));
	      this.myChart.setOption(options);
	      this.legendArr = options.series;
	      this.legendArr.forEach(function (data) {
	        data.selected = true;
	      });
	      this.$root.charts.push(this.myChart);
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    _getCityData: function _getCityData() {
	      var _this = this;
	
	      _axios2.default.get('static/data/cityData.json').then(function (res) {
	        _this.geoCoordMap = res.data;
	        _this.$nextTick(function () {
	          _this._getMyChart();
	        });
	      });
	    },
	    convertData: function convertData(data) {
	      var res = [];
	      for (var i = 0; i < 4; i++) {
	        var l = data.length;
	        var x = parseInt(Math.random() * l);
	        var geoCoord = this.geoCoordMap[data[x].name];
	        // let geoCoord = this.geoCoordMap[data[i].name];
	        if (geoCoord) {
	          res.push({
	            name: data[x].name,
	            // name: data[x].name,
	            value: geoCoord.concat(Math.random() * 200)
	            // value: geoCoord.concat(data[i].value)
	          });
	        }
	      }
	      return res;
	    },
	    _getMyChart: function _getMyChart() {
	      var _this2 = this;
	
	      _axios2.default.get('static/data/point/testData.json').then(function (res) {
	        var options = {
	          // backgroundColor: '#404a59',
	          title: {
	            show: false
	          },
	          tooltip: {
	            trigger: 'item',
	            formatter: function formatter(params) {
	              return params.name + ' : ' + params.value[2];
	            }
	          },
	          legend: {
	            show: false
	          },
	          visualMap: {
	            min: 0,
	            max: 200,
	            bottom: 50,
	            splitNumber: 5,
	            inRange: {
	              color: ['#255B78', '#2A7484', '#2F9696', '#3BBCB0', '#51D4EB']
	            },
	            textStyle: {
	              color: '#fff'
	            }
	          },
	          geo: {
	            map: 'china',
	            label: {
	              emphasis: {
	                show: false
	              }
	            },
	            zoom: 1,
	            top: 50,
	            itemStyle: {
	              normal: {
	                color: '#3c4247',
	                opacity: 0.6,
	                borderColor: 'rgba(255, 255, 255, 0.35)'
	              },
	              emphasis: {
	                color: '#2a333d'
	              }
	            }
	          },
	          series: [{
	            name: '标签1',
	            type: 'scatter',
	            coordinateSystem: 'geo',
	            symbolSize: function symbolSize(val) {
	              return val[2] / 6;
	            },
	            label: {
	              normal: {
	                show: false
	              },
	              emphasis: {
	                show: false
	              }
	            },
	            itemStyle: {
	              emphasis: {
	                borderColor: '#fff',
	                borderWidth: 1
	              }
	            },
	            data: _this2.convertData(res.data)
	          }, {
	            name: '标签2',
	            type: 'scatter',
	            coordinateSystem: 'geo',
	            symbolSize: function symbolSize(val) {
	              return val[2] / 6;
	            },
	            label: {
	              normal: {
	                show: false
	              },
	              emphasis: {
	                show: false
	              }
	            },
	            itemStyle: {
	              emphasis: {
	                borderColor: '#fff',
	                borderWidth: 1
	              }
	            },
	            data: _this2.convertData(res.data)
	          }, {
	            name: '标签3',
	            type: 'scatter',
	            coordinateSystem: 'geo',
	            symbolSize: function symbolSize(val) {
	              return val[2] / 6;
	            },
	            label: {
	              normal: {
	                show: false
	              },
	              emphasis: {
	                show: false
	              }
	            },
	            itemStyle: {
	              emphasis: {
	                borderColor: '#fff',
	                borderWidth: 1
	              }
	            },
	            data: _this2.convertData(res.data)
	          }]
	        };
	        _this2._init(options);
	      });
	    }
	  },
	  components: {
	    'v-header': _header2.default,
	    'v-filter': _filter2.default
	  }
	};

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(554)
	
	var Component = __webpack_require__(22)(
	  /* script */
	  __webpack_require__(242),
	  /* template */
	  __webpack_require__(574),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(561)
	
	var Component = __webpack_require__(22)(
	  /* script */
	  __webpack_require__(243),
	  /* template */
	  __webpack_require__(581),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(563)
	
	var Component = __webpack_require__(22)(
	  /* script */
	  __webpack_require__(245),
	  /* template */
	  __webpack_require__(583),
	  /* scopeId */
	  "data-v-c2e4a4f2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(555)
	
	var Component = __webpack_require__(22)(
	  /* script */
	  __webpack_require__(247),
	  /* template */
	  __webpack_require__(575),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(564)
	
	var Component = __webpack_require__(22)(
	  /* script */
	  __webpack_require__(249),
	  /* template */
	  __webpack_require__(584),
	  /* scopeId */
	  "data-v-df59e846",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 574:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mainApp"
	  }, [_c('router-view', {
	    staticClass: "router-view"
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "line"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "legendArr": _vm.legendArr,
	      "myChart": _vm.myChart
	    }
	  }), _vm._v(" "), (_vm.myChart._dom) ? _c('v-filter', {
	    attrs: {
	      "myChart": _vm.myChart
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "main"
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columnChart"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "legendArr": _vm.legendArr,
	      "myChart": _vm.myChart
	    }
	  }), _vm._v(" "), (_vm.myChart._dom) ? _c('v-filter', {
	    attrs: {
	      "myChart": _vm.myChart
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "main"
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filter"
	  }, [_c('div', {
	    staticClass: "startTime"
	  }, [_c('span', {
	    staticClass: "timeText"
	  }, [_vm._v("起始时间")]), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "type": "date",
	      "placeholder": "选择日期"
	    },
	    model: {
	      value: (_vm.startDate),
	      callback: function($$v) {
	        _vm.startDate = $$v
	      },
	      expression: "startDate"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "myCalendar"
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "endTime"
	  }, [_c('span', {
	    staticClass: "timeText"
	  }, [_vm._v("截止时间")]), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "type": "date",
	      "placeholder": "选择日期"
	    },
	    model: {
	      value: (_vm.endDate),
	      callback: function($$v) {
	        _vm.endDate = $$v
	      },
	      expression: "endDate"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "myCalendar"
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showProduct),
	      expression: "showProduct"
	    }],
	    staticClass: "product-wrapper"
	  }, [_c('div', {
	    staticClass: "products"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.pro_filter_flag),
	      expression: "pro_filter_flag"
	    }],
	    staticClass: "all",
	    on: {
	      "click": function($event) {
	        _vm.selectAll()
	      }
	    }
	  }, [_c('checkbox', {
	    attrs: {
	      "isChecked": _vm.selectAll_flag
	    }
	  }), _vm._v("\n        全选\n      ")], 1), _vm._v(" "), _c('div', {
	    staticClass: "pro",
	    on: {
	      "click": function($event) {
	        _vm.showProPane()
	      }
	    }
	  }, [_vm._v("\n        产品"), _c('i', {
	    staticClass: "arrow"
	  })])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.pro_filter_flag),
	      expression: "pro_filter_flag"
	    }],
	    staticClass: "pro_list"
	  }, [_c('ul', _vm._l((_vm.pro_list), function(pro, index) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          _vm.pro_toggle(pro, index)
	        }
	      }
	    }, [_c('checkbox', {
	      attrs: {
	        "isChecked": pro.selected
	      }
	    }), _c('span', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(pro.name))])], 1)
	  }))])])])
	},staticRenderFns: []}

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "multipleColumn"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "legendArr": _vm.legendArr,
	      "myChart": _vm.myChart
	    }
	  }), _vm._v(" "), (_vm.myChart._dom) ? _c('v-filter', {
	    attrs: {
	      "myChart": _vm.myChart
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "main"
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
	    staticClass: "legend-wrapper"
	  }, [_c('ul', _vm._l((_vm.legendArr), function(legend, index) {
	    return _c('li', {
	      style: (_vm.styleArr[index]),
	      on: {
	        "mouseout": function($event) {
	          _vm.donwplay(index)
	        },
	        "mouseover": function($event) {
	          _vm.highlight(index)
	        },
	        "click": function($event) {
	          _vm.legendToggle(legend)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(legend.name) + "\n      ")])
	  }))])])
	},staticRenderFns: []}

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "v-checkbox",
	    class: {
	      'checked': _vm.isChecked
	    }
	  })
	},staticRenderFns: []}

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "point"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "legendArr": _vm.legendArr,
	      "myChart": _vm.myChart
	    }
	  }), _vm._v(" "), (_vm.myChart._dom) ? _c('v-filter', {
	    attrs: {
	      "myChart": _vm.myChart
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "main"
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('div', {
	    staticClass: "flex-container column"
	  }, [_c('div', {
	    staticClass: "item one",
	    staticStyle: {
	      "transform": "translate(-22.4%,-33.5%) scale(0.33)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clickChart('1')
	      }
	    }
	  }, [_c('multipleColumn')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item two",
	    staticStyle: {
	      "transform": "translate(-22.4%,0.5%) scale(0.33)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clickChart('2')
	      }
	    }
	  }, [_c('column')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item three",
	    staticStyle: {
	      "transform": "translate(-22.4%,34.5%) scale(0.33)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clickChart('3')
	      }
	    }
	  }, [_c('v-line')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item four active",
	    staticStyle: {
	      "transform": "translate(43.7%, 0) scale(1)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clickChart('4')
	      }
	    }
	  }, [_c('point')], 1)])])
	},staticRenderFns: []}

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "heat"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "legendArr": _vm.legendArr,
	      "myChart": _vm.myChart
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "main"
	  })], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.77643bef8d8b5d1edcf6.js